import { Phone, Mail, MapPin, MessageCircle, CalendarCheck } from "lucide-react";
import { Link } from "react-router-dom";
import { SITE, telLink, mailLink, waLink } from "../data/siteConfig";
import { useSEO } from "../components/SEO";
import FadeIn from "../components/FadeIn";
import EnquiryForm from "../components/EnquiryForm";

const ContactPage = () => {
  useSEO(
    "Contact Dr Lal PathLabs Collection Center Bhopal | 8959830932",
    "Contact Dr Lal PathLabs Collection Center Bhopal. Call 8959830932, WhatsApp or email lalpathlabsbhopal@outlook.com for test enquiries."
  );

  return (
    <div>
      <section className="bg-[#0B3056] py-16">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <FadeIn>
            <p className="mb-3 text-xs font-semibold uppercase tracking-[0.2em] text-blue-200">Contact Us</p>
            <h1 className="font-heading text-3xl font-extrabold tracking-tight text-white sm:text-4xl">
              Contact {SITE.fullName} Bhopal
            </h1>
            <p className="mt-4 max-w-2xl text-base text-blue-100 md:text-lg">
              Reach us by phone, WhatsApp, email or the enquiry form — we&apos;re happy to help.
            </p>
          </FadeIn>
        </div>
      </section>

      <section className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8">
        <div className="grid gap-10 lg:grid-cols-2">
          <FadeIn>
            <div className="space-y-5">
              <div className="rounded-2xl border border-gray-100 bg-white p-7 shadow-sm">
                <h2 className="font-heading text-xl font-bold text-[#0B3056]">{SITE.fullName}</h2>
                <ul className="mt-5 space-y-4 text-sm text-slate-700">
                  <li className="flex items-start gap-3">
                    <MapPin size={18} className="mt-0.5 shrink-0 text-[#1E88E5]" aria-hidden="true" />
                    <span>{SITE.city}, {SITE.region}</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <Phone size={18} className="mt-0.5 shrink-0 text-[#1E88E5]" aria-hidden="true" />
                    <a href={telLink} data-testid="contact-phone-link" className="font-semibold text-[#0B3056] hover:text-[#1E88E5]">{SITE.phone}</a>
                  </li>
                  <li className="flex items-start gap-3">
                    <Mail size={18} className="mt-0.5 shrink-0 text-[#1E88E5]" aria-hidden="true" />
                    <a href={mailLink} data-testid="contact-email-link" className="break-all font-semibold text-[#0B3056] hover:text-[#1E88E5]">{SITE.email}</a>
                  </li>
                </ul>
                <div className="mt-6 flex flex-col gap-3 sm:flex-row sm:flex-wrap">
                  <a href={telLink} data-testid="contact-call-button" className="inline-flex min-h-[44px] items-center justify-center gap-2 rounded-full bg-[#1E88E5] px-5 py-2.5 text-sm font-semibold text-white transition-colors hover:bg-[#1565C0]">
                    <Phone size={16} aria-hidden="true" /> Call Now
                  </a>
                  <a href={waLink()} target="_blank" rel="noopener noreferrer" data-testid="contact-whatsapp-button" className="inline-flex min-h-[44px] items-center justify-center gap-2 rounded-full bg-[#25D366] px-5 py-2.5 text-sm font-semibold text-white transition-colors hover:bg-[#1eb856]">
                    <MessageCircle size={16} aria-hidden="true" /> WhatsApp
                  </a>
                  <a href={mailLink} data-testid="contact-email-button" className="inline-flex min-h-[44px] items-center justify-center gap-2 rounded-full border-2 border-[#1E88E5] px-5 py-2.5 text-sm font-semibold text-[#1E88E5] transition-colors hover:bg-[#F0F7FA]">
                    <Mail size={16} aria-hidden="true" /> Email Us
                  </a>
                  <Link to="/book-a-test" data-testid="contact-book-button" className="inline-flex min-h-[44px] items-center justify-center gap-2 rounded-full border-2 border-[#0B3056] px-5 py-2.5 text-sm font-semibold text-[#0B3056] transition-colors hover:bg-[#F0F7FA]">
                    <CalendarCheck size={16} aria-hidden="true" /> Book a Test
                  </Link>
                </div>
              </div>

              <div className="rounded-2xl border border-dashed border-[#1E88E5]/40 bg-[#F0F7FA] p-7" data-testid="map-placeholder">
                <span className="flex h-12 w-12 items-center justify-center rounded-full bg-white text-[#1E88E5] shadow-sm">
                  <MapPin size={22} aria-hidden="true" />
                </span>
                <h2 className="mt-4 font-heading text-lg font-bold text-[#0B3056]">Find Our Collection Center</h2>
                <p className="mt-2 text-sm leading-relaxed text-slate-600">
                  Our collection center is located in Bhopal, Madhya Pradesh. The interactive map will be available
                  here soon — please call us for directions to the center.
                </p>
              </div>
            </div>
          </FadeIn>

          <FadeIn delay={0.1}>
            <div className="rounded-2xl border border-gray-100 bg-white p-6 shadow-sm sm:p-8">
              <h2 className="font-heading text-xl font-bold text-[#0B3056]">Send an Enquiry</h2>
              <p className="mt-2 text-sm text-slate-600">
                Fill in the form and our team will get back to you regarding your enquiry.
              </p>
              <div className="mt-6">
                <EnquiryForm mode="contact" enquiryType="contact" testIdPrefix="contact" />
              </div>
            </div>
          </FadeIn>
        </div>
      </section>
    </div>
  );
};

export default ContactPage;
